import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { TrialBanner } from '@/routes/trial/TrialBanner';

import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';

/** Sidebar + top bar + the routed screen (ported from legalcrm, without the assistant), and the free-trial banner. */
export function AppShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-canvas">
      {/* First tab stop on every page, so keyboard users skip the navigation. */}
      <a
        href="#main"
        className="sr-only-focusable fixed left-3 top-3 z-50 rounded bg-primary px-3 py-2 text-sm font-medium text-primary-ink"
      >
        Skip to content
      </a>

      <Sidebar open={sidebarOpen} onNavigate={() => setSidebarOpen(false)} />

      <div className="lg:pl-64">
        <TrialBanner />
        <TopBar onOpenSidebar={() => setSidebarOpen(true)} />
        <main id="main" tabIndex={-1} className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
